// extracted by mini-css-extract-plugin
export default {"header":"PacienteEscalasControl_header__pT361"};